import React from "react";
import * as zenscroll from "zenscroll";

/**
 * Wrapper for an a tag that scrolls to the target. If JS is disabled, this still functions via the URL hash.
 */
export class ScrollAnchor extends React.PureComponent<{ target: string, toTarget?: boolean; onClick?: () => void, tabIndex?: number }> {

  private handleClick = (e: React.MouseEvent<HTMLAnchorElement>): boolean => {
    e.preventDefault();

    const target = document.getElementById(this.props.target);
    if (target) {
      if (this.props.toTarget) {
        zenscroll.to(target)
      } else {
        zenscroll.center(target);
      }
    }
    this.props.onClick?.()
    return true;
  };

  public render() {
    return (
      <a href={`#${this.props.target}`} onClick={e => this.handleClick(e)} tabIndex={this.props.tabIndex || 0}>
        {this.props.children}
      </a>
    );
  }
}
